import { get, put } from '../httpMethods';
import { ApiResponse } from '../../types/api';
import type {
  RetentionOverview,
  RetentionPolicy,
  RetentionResource,
  RetentionUnit,
} from '../../types/retention';

export interface SaveRetentionPolicyInput {
  value: number;
  unit: RetentionUnit;
  enabled?: boolean;
}

export const retentionService = {
  /** Saved retention policies and the daily cleanup schedule. */
  getRetentionPolicies: (): Promise<ApiResponse<RetentionOverview>> => {
    return get<RetentionOverview>('/retention-policies');
  },

  /**
   * Save the retention window for a resource. Nothing is deleted immediately —
   * the daily cron applies it at 02:00 BD time.
   */
  saveRetentionPolicy: (
    resource: RetentionResource,
    data: SaveRetentionPolicyInput,
  ): Promise<ApiResponse<RetentionPolicy>> => {
    return put<RetentionPolicy>(`/retention-policies/${resource}`, data);
  },
};
